import styled from 'styled-components'
import { FormControlLabel } from '@mui/material'

export const FormControlLabelStyled = styled(FormControlLabel)`
    .Mui-checked {
        color: #17b67c !important
    }
`